import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UUID } from '@macs-frontend/core/utils/uuid';
import { FormState } from 'ngrx-forms';
import { BookingPerson, BookModalActionTypes, BookModalChecks, MdAction } from '../..';
import { PersonSelectData } from '@macs-frontend/features/planner-shared/person-select-modal/person-select-modal.component';

@Component({
  selector: 'md-book-modal',
  templateUrl: './book-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookModalComponent {
  @Input() show = false;
  // @ts-expect-error
  @Input() model: BookingPerson | PersonSelectData;
  // @ts-expect-error
  @Input() action: MdAction;
  // @ts-expect-error
  @Input() actionType: BookModalActionTypes;
  // @ts-expect-error
  @Input() compositionRoleUuidControl: FormState<string>;
  // @ts-expect-error
  @Input() checks: BookModalChecks;
  // @ts-expect-error
  @Input() checking: boolean;
  @Input() isBookingInProgress = false;

  @Output() toggleModal = new EventEmitter<boolean>();
  @Output() selectActionType = new EventEmitter<BookModalActionTypes>();
  @Output() makeBooking = new EventEmitter<BookModalActionTypes>();

  actionTypes = BookModalActionTypes;

  showErrors = true;
  showWarnings = false;
  showRemarks = false;
  showInfo = false;

  toggleModalHandle(forceValue = !this.show) {
    this.toggleModal.emit(forceValue);
    this.show = forceValue;
  }

  bookModalRolesTrackBy(_index: number, option: { uuid: UUID; roleName: string }) {
    return option.uuid;
  }

  getBookModalRolesOptions() {
    return (this.action.actionTeam || this.action.teamCost).compositionRoles
      .filter(compositionRole => compositionRole.quantity > compositionRole.fullness)
      .map(compositionRole => {
        const fullness = compositionRole.fullness;
        const quantity = compositionRole.quantity;
        // eslint-disable-next-line functional/no-let
        let text = compositionRole.roleName;
        if (
          compositionRole.scheduleStartLocation &&
          compositionRole.scheduleStartLocation.name
        ) {
          text = `${text} - ${compositionRole.scheduleStartLocation.name}`;
        }

        return {
          uuid: compositionRole.uuid,
          roleName: `${text} (${fullness}/${quantity})`,
        };
      });
  }

  canShowBookModalIssues(): boolean {
    return (
      this.checks.errors.length !== 0 ||
      this.checks.warnings.length !== 0 ||
      this.checks.remarks.length !== 0 ||
      this.checks.info.length !== 0
    );
  }

  toggleErrors(forceValue = !this.showErrors) {
    this.showErrors = forceValue;
  }

  toggleWarnings(forceValue = !this.showWarnings) {
    this.showWarnings = forceValue;
  }

  toggleRemarks(forceValue = !this.showRemarks) {
    this.showRemarks = forceValue;
  }

  toggleInfo(forceValue = !this.showInfo) {
    this.showInfo = forceValue;
  }

  canShowResponsibilityWarning() {
    return (
      !this.checking &&
      this.checks.warnings.length !== 0 &&
      this.checks.errors.length === 0
    );
  }

  stopPropagation(event: MouseEvent | Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  getCompositionRoleNameByUuid(compositionRoleUuid: UUID) {
    const compositionRole = (
      this.action.actionTeam || this.action.teamCost
    ).compositionRoles.find(
      _compositionRole => _compositionRole.uuid === compositionRoleUuid,
    );

    return compositionRole && compositionRole.roleName;
  }
}
